import 'core-js/es';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import { AliveScope } from 'react-activation';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import zhCN from 'antd/es/locale/zh_CN';
import dayjs from 'dayjs';
import store from '@/store/store';
import { getCss } from '@/common/utils/get-css';
import { getScript } from '@/common/utils/get-script';
import { initSentry } from 'src/common/utils/sentry';
import { ConfigProvider, message } from 'antd';
import App from './app';
import 'dayjs/locale/zh-cn';
import './global.less';
dayjs.locale('zh-cn');
import 'src/common/utils/bigdata';

window.getScript = getScript;
window.getCss = getCss;

initSentry();

if (process.env.NODE_ENV === 'development') {
  // 本地开发环境过滤 ResizeObserver loop limit exceeded 报错
  window.addEventListener('error', (err) => {
    try {
      if (err.type === 'error') {
        // 微应用需要设置 (container || document)
        const iframe: any = document.querySelector('#webpack-dev-server-client-overlay');
        if (err.message.indexOf('ResizeObserver loop limit exceeded') > -1 || err.message.indexOf('ResizeObserver loop completed with undelivered notifications') > -1) {
          iframe.contentWindow.document.querySelector('#webpack-dev-server-client-overlay-div button').click();
        }
      }
    } catch (_) {}
  });
} else {
  // 线上环境不再提示接口请求被取消
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && event.reason.indexOf instanceof Function && event.reason?.indexOf('您取消了请求') > -1) {
      event.preventDefault();
    }
  });
}


message.config({
  maxCount: 3, // 最大显示数, 超过限制时，最早的消息会被自动关闭
  top: 50, // 到页面顶部距离
});

ReactDOM.render(
  <BrowserRouter>
    <AliveScope>
      <Provider store={store}>
        <ConfigProvider locale={zhCN}>
          <App />
        </ConfigProvider>
      </Provider>
    </AliveScope>
  </BrowserRouter>,
  document.getElementById('root')
);
